/*
 * Javascript for stay in the loop page
*/
(function($) {
	/*if($('.stay-in-the-loop-container').length) {
		if($('.group').length) {
			$('.group').matchHeight();
		}
		$(document).on('submit', 'form', function(){
			showLoadingBar();
			$('.form-btn').addClass('spinner');
		});
		$(document).on('change', '.checkbox input', function(){
			if(this.checked) {
				$(this).closest('.group').removeClass('border-site-border').addClass('border-primary-200');
			} else {
				$(this).closest('.group').removeClass('border-primary-200').addClass('border-site-border');
			}
		});
		$(document).on('click', '.checkbox', function(){
			input = $(this).find('input');
			if((input.checked)||(input.is(':checked'))) {
				input.prop('checked', false).change();
			} else {
				input.prop('checked', true).change();
			}
		});
	}*/
})(jQuery);
